import { BaseDTO } from '../global/base.dto';
import { CollectiveAgreementListDTO } from '../collective-agreement/collective-agreement-list.dto';

export class CollectiveAgreementRateDTO extends BaseDTO {

    name: string;

    monday: boolean;

    tuesday: boolean;

    wednesday: boolean;

    thursday: boolean;

    friday: boolean;

    saturday: boolean;

    sunday: boolean;

    from: Date | string;

    to: Date | string;

    type: number;

    addition: number;

    additionType: number;

    collectiveAgreements: Array<CollectiveAgreementListDTO>;

}
